import { SET_USER_SETTINGS } from '../actions/users-profile-actions-types';

const INITIAL_USER_SETTINGS_STATE = { results: '' }

export function setUserSettingsReducer(state = INITIAL_USER_SETTINGS_STATE, action) {
    switch (action.type) {
        case SET_USER_SETTINGS:
            return { results: action.payload }
        default:
            return state;
    }
}